import {CustomSpineAnimation} from "./CustomSpineAnimation";

export class BlackjackAnimation extends CustomSpineAnimation {

    private static readonly ANIMATION_CONFIG = {
        NAME: "blackjack",
        STATES: {
            IDLE_HIDDEN: "idle_hidden",
            IDLE_SHOW: "idle_visible",
            SHOW: "show",
        },
    };

    constructor() {
        super(BlackjackAnimation.ANIMATION_CONFIG.NAME);
        this.hide();
    }

    public show(): void {
        this.play(BlackjackAnimation.ANIMATION_CONFIG.STATES.SHOW);
    }

    public hide(): void {
        this.play(BlackjackAnimation.ANIMATION_CONFIG.STATES.IDLE_HIDDEN);
    }
}



// WEBPACK FOOTER //
// ./src/app/BlackjackAnimation.ts